import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "common/queryKeys";
import { fetchApi } from "common/utils/Api";
import {
  DefaultStockClassDemandTemplates,
  DefaultStockClasses,
} from "./defaultStockClassesTypes";

async function fetchDefaultStockClasses(): Promise<DefaultStockClasses> {
  return fetchApi(`defaultStockClasses`, {
    method: "GET",
  }) as Promise<DefaultStockClasses>;
}

async function fetchDefaultStockClassDemandTemplates(): Promise<DefaultStockClassDemandTemplates> {
  return fetchApi(`defaultStockClasses/demandTemplates`, {
    method: "GET",
  }) as Promise<DefaultStockClassDemandTemplates>;
}

export function useDefaultStockClasses() {
  return useQuery({
    queryKey: queryKeys.defaultStockClasses.all,
    queryFn: fetchDefaultStockClasses,
    staleTime: 1000 * 60 * 60, // 1 hour - these are static reference data
  });
}

export function useDefaultStockClassDemandTemplates() {
  return useQuery({
    queryKey: queryKeys.defaultStockClasses.demandTemplates,
    queryFn: fetchDefaultStockClassDemandTemplates,
    staleTime: 1000 * 60 * 60, // 1 hour - these are static reference data
  });
}

/**
 * Prefetch default stock classes (used during initialization)
 */
export async function fetchDefaultStockClassesQuery(
  queryClient: import("@tanstack/react-query").QueryClient
): Promise<DefaultStockClasses> {
  const data = await fetchDefaultStockClasses();
  queryClient.setQueryData(queryKeys.defaultStockClasses.all, data);
  return data;
}
